import HighlightAltOutlinedIcon from '@mui/icons-material/HighlightAltOutlined';
import questionnaireBuilderPath from '../../helpers/questionnaire/questionnaireBuilderPath';
import { sentinelToEmpty } from '../../helpers/sentinelValue';
import Location from "../../hooks/Location"
import { useFirestoreID, useFirestoreGeneral } from '../../firebase/useFirestore';
import EffectMeta from '../../components/effects/EffectMeta';
import { useState } from 'react';
import { client } from '../../hooks/Client';
import { db } from "../../firebase/config";
import { useHistory } from "react-router-dom";
import EffectActivities from '../../components/effects/EffectActivities';
import ReadOnlyGuard from '../../components/common/ReadOnlyGuard';

const AddIndicatorsToQuestionaire = () => {

    // State
    const [checkedIndicators, setCheckedIndicators] = useState([])

    // Hooks
    const questionaireId = Location()[3]
    const researchId = sentinelToEmpty(Location()[4])
    const history = useHistory()

    // Firestore
    const questionaireField = useFirestoreID('QuestionnaireFields', questionaireId ? questionaireId : '')
    // AI-CONTEXT: See docs/pitfalls.md#database-empty-string-is-a-real-stored-value
    // "Nog in geen vragenlijst" is `QuestionnaireID: ''` in de data, maar '' is
    // in de leesmotor het signaal voor "waarde nog onbekend": een where op ''
    // slaat de hele query over, dus de lijst bleef leeg terwijl de vragen er
    // wel waren. Daarom hier alleen op `Indicator` filteren en de rest in de
    // pagina zelf — dat vangt meteen de oudere vragen op waar `QuestionnaireID`
    // helemaal ontbreekt.
    const indicators = useFirestoreGeneral('QuestionnaireFields', 'Indicator', 'true')

    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    // De motor geeft '' terug tot de eerste snapshot binnen is. "Er zijn geen
    // gekoppelde vragen" is een bewering aan de lezer, en die is onwaar zolang
    // de gegevens onderweg zijn — dus 'weet ik nog niet' krijgt een eigen tak.
    const loaded = Array.isArray(indicators)

    // Alleen vragen die aan een effect hangen en nog in geen vragenlijst zitten.
    const availableIndicators = loaded
        ? indicators.filter(indicator =>
            Array.isArray(indicator.EffectId) && indicator.EffectId.length > 0 &&
            !indicator.QuestionnaireID)
        : []

    // Update the selected question
    const handleCheckboxChange = (id, docid) => {
        setCheckedIndicators(prevState => {
            const index = prevState.findIndex(item => item.id === id);
            if (index > -1) {
                // The question is currently checked, remove it from the array
                return prevState.filter((_, i) => i !== index);
            } else {
                // The question is not checked, add it to the array
                return [...prevState, {id, docid}];
            }
        });
    };

    // Add questionaire field
    const updateQuestionaireField = async (item, index) => {

        const fieldCount = Array.isArray(questionaireField) ? questionaireField.length : 0

        await db.collection('QuestionnaireFields')
        .doc(item.docid)
        .update({
            QuestionnaireID: questionaireId,
            Position: fieldCount + 1 + index,
        })
    }

    // Save indicators to questionaire
    const updateIndicators = (e) => {

        checkedIndicators.map(async (item, index) => {

            // For each checked indicator, update the questionaire field
            await updateQuestionaireField(item, index)
                
        })

        history.push(questionnaireBuilderPath(client, 'questionairebuilder', questionaireId, researchId))


    }

  return (
    <div className="main">
        <div className="main-container" >
            <div className='page-header'>
                <HighlightAltOutlinedIcon/>
                <h1>Vragen toevoegen aan vragenlijst</h1>
            </div>
            <ReadOnlyGuard edit="measurement.edit">
            <div className="table-container dashboard-container">
                <h2>Vragen</h2>
                {!loaded ?
                    <p>Vragen laden…</p>
                : availableIndicators.length < 1 ?
                    <p>Er zijn geen gekoppelde vragen die nog aan een vragenlijst toegevoegd kunnen worden. Vragen verschijnen hier zodra je ze in je impactstrategie aan een effect koppelt en ze nog in geen enkele vragenlijst staan.</p>
                :
                <>
                <table>
                    <tr>
                        <th>SELECTEER</th>
                        <th>VRAAG</th>
                        <th>EFFECT</th>
                        <th>AVTIVITEIT(EN)</th>
                    </tr>
                        {availableIndicators.map((indicator, index) => (
                             <tr key={indicator.ID}>
                                <td>
                                    <input 
                                    type="checkbox" 
                                    checked={checkedIndicators.some(q => q.id === indicator.ID)}
                                    onChange={() => handleCheckboxChange(indicator.ID, indicator.docid)}
                                    />
                                </td>
                                <td>
                                    <p className='table-p'>{indicator.Question}</p>
                                </td>
                                <td>
                                    {indicator.EffectId.map((item) => (
                                         <EffectMeta item={item} key={item}/>
                                    ))}
                                </td>
                                <td>
                                    {indicator.EffectId.map((item) => (
                                        <EffectActivities effectId={item} key={item}/>
                                    ))}
                                </td>
                            </tr>
                        ))}
                </table>
                <div className='button-container add-indicators-button-container'>
                    <button onClick={updateIndicators}>Opslaan</button>
                </div>
                </>
                }
            </div>
            </ReadOnlyGuard>

            
        </div>
    </div>
  )
}

export default AddIndicatorsToQuestionaire
